import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  fetchShippingLabels,
  fetchCP,
  fetchActiveReportsMetaData
} from '../actions/sessionActions';
import { Select, Radio, Button, Upload, Icon, Row, Col } from 'antd';
import { parseQueryString } from '../utils/assetUtils';
const { Option } = Select;

export class CreateShippingLabels extends Component {
  state = { queryParams: {}, enterprise: [], account_id: [], cp_id: [] };
  componentWillMount = () => {
    const queryParams = parseQueryString(this.props.location.search);
    this.props.fetchActiveReportsMetaData('enterprise').then(res => {
      const enterprise = res.enterprise.list
        .filter(item => {
          return item.id === Number(queryParams.enterprise);
        })
        .map(item => item.id);
      this.setState({ enterprise });
    });
    if (queryParams.cp_id || queryParams.account_id) {
      this.props.fetchCP(queryParams.enterprise).then(res => {
        if (queryParams.cp_id) {
          const cp_id = res.cps
            .filter(item => {
              return item.id === Number(queryParams.cp_id);
            })
            .map(item => item.id);
          this.setState({ cp_id });
        }
        if (queryParams.cp_id) {
          const account_id = res.accounts
            .filter(item => {
              return item.id === Number(queryParams.account_id);
            })
            .map(item => item.id);
          this.setState({ account_id });
        }
      });
    }
    this.setState({ queryParams });
    this.props.fetchShippingLabels(queryParams);
  };
  handleChange = value => {
    const { queryParams } = this.state;
    queryParams.enterprise = value;
    this.setState({ queryParams, enterprise: value });
    this.props.fetchCP(value);
  };
  render() {
    const { metadata } = this.props;
    // console.log(metadata.enterprise.list, this.state.enterprise);
    return (
      <div>
        <h1>Create enterprise shipping label</h1>
        <Row className="margin-bottom-10">
          <Col span={3}>
            <span>Enterprise:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Select
              placeholder="Please select an enterprise"
              style={{ width: '100%' }}
              disabled={true}
              value={this.state.enterprise}
              onChange={this.handleChange}
            >
              {metadata.enterprise.list.map((enterprise, i) => (
                <Option key={i} value={enterprise.id}>
                  {enterprise.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={3}>
            <span>Courier Partner:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Select
              placeholder="Please select courier partner"
              disabled={true}
              value={this.state.cp_id}
              mode="multiple"
              style={{ width: '100%' }}
            >
              {metadata.cp.list.map((cp, i) => (
                <Option key={i} value={cp.id}>
                  {cp.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={3}>
            <span>Account:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Select
              placeholder="Please select account"
              disabled={true}
              value={this.state.account_id}
              mode="multiple"
              style={{ width: '100%' }}
            >
              {metadata.account.list.map((account, i) => (
                <Option key={i} value={account.id}>
                  {`${account.cp_name} - ${account.name}`}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={3}>
            <span>Sample Template:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Radio.Group>
              <Radio value="a">item 1</Radio>
              <Radio value="b">item 2</Radio>
              <Radio value="c">item 3</Radio>
            </Radio.Group>
          </Col>
          <Col span={3}>
            <span>Upload:</span>
          </Col>
          <Col span={21} className="margin-bottom-20">
            <Upload name="logo" action="/upload.do" listType="picture">
              <Button>
                <Icon type="upload" /> Click to upload
              </Button>
            </Upload>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
              Clear
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

CreateShippingLabels.propTypes = {
  shippingLabels: PropTypes.object,
  config: PropTypes.object,
  location: PropTypes.object,
  metadata: PropTypes.object,
  fetchShippingLabels: PropTypes.func,
  fetchCP: PropTypes.func,
  fetchActiveReportsMetaData: PropTypes.func
};

CreateShippingLabels.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  shippingLabels: state.session.shippingLabels
});

const mapDispatchToProps = dispatch => ({
  fetchShippingLabels: query => dispatch(fetchShippingLabels(query)),
  fetchCP: query => dispatch(fetchCP(query)),
  fetchActiveReportsMetaData: query =>
    dispatch(fetchActiveReportsMetaData(query))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateShippingLabels)
);
